import React from 'react';

import Modal from 'src/components/modal/modal';
import './sov-modal.scss';

export const SovModal = (props) => {
  return (
    <Modal
      modalStyle="SOVModal"
      show={props.show}
      cardStyle="resolve-modal-card"
      header={() => (
        <p className="resolve-modal-head heading-four has-text-centered">
          Biz Wallet Pro journey change
        </p>
      )}
      headerStyle="resolve-modal-card-head"
      body={() => (
        <p className="content-large-extra">
          Biz Wallet Pro requires additional information. Please complete the additional fields as
          required.
        </p>
      )}
      bodyStyle="resolve-modal-card-body has-text-centered"
      footer={() => (
        <button
          className={'button is-primary is-pulled-right'}
          automationid="Onboarding_Choose_Solution_Button_Reduce_Delivery_Quantity_Yes"
          onClick={props.handleConfirm}
        >
          Continue application
        </button>
      )}
      footerStyle="resolve-modal-card-foot"
      backdropStyle="backdrop"
    />
  );
};
